import React from 'react';
import { supplierSetoffService } from 'api/services';
import { useSupplierSetoffs } from 'hooks/api/useCommercial';
import PartySetoffScreen, { type PartySetoffConfig } from 'components/modules/accounts/setoff/PartySetoffScreen';

// ADR-0051: Supplier Set-off — match a supplier's DEBIT balances (on-account debit notes,
// advances) against its open BILLS without moving money. ADR-0060: Mark withheld closes disputed
// bills with no payment; each amount stays open on the supplier's ledger as a withheld item.
// The screen itself is shared with Customer Set-off (PartySetoffScreen).
const SUPPLIER_SETOFF: PartySetoffConfig = {
  role: 'SUPPLIER',
  screenCode: 'supplier-setoff',
  title: 'Supplier Set-off',
  description: "Match a supplier's debit balances against its open bills, or mark disputed bills withheld — no money moves (ADR-0051, ADR-0060)",
  service: supplierSetoffService,
  useList: useSupplierSetoffs,
  partyType: 'SUPPLIER',
  partyWord: 'Supplier',
  balanceSide: 'DR',
  balanceTitle: 'Debit balances',
  balanceHint: 'On-account debit notes and advances — what the supplier owes you.',
  openTitle: 'Open bills',
  openHint: 'What you owe the supplier, including amounts you withheld.',
  deductionWord: 'withheld',
  markLabel: 'Mark withheld',
  markHint: 'For bills you dispute and are not paying for now. Each bill closes; the amount stays open on the supplier\'s ledger as withheld, with its reason, until you pay it or set a debit note off against it.',
};

interface SupplierSetoffScreenProps { moduleIcon?: string; tabId?: string; moduleName?: string; }

const SupplierSetoffScreen: React.FC<SupplierSetoffScreenProps> = (props) => <PartySetoffScreen config={SUPPLIER_SETOFF} {...props} />;

export default SupplierSetoffScreen;
